import React, { createContext, useReducer } from 'react'
import { Action, ContextType } from '@/types/context'
import reducer, { State, ActionTypes } from './reducer'

interface PropTypes {
  children: React.ReactNode
}

const initialState: State = {
  notes: [],
  loading: false
}

const NotesContext = createContext<ContextType<State, Action<ActionTypes>>>({
  ...initialState,
  dispatch: () => null
})

export const NotesProvider = ({ children }: PropTypes) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  return <NotesContext.Provider value={{ ...state, dispatch }}>
    {children}
  </NotesContext.Provider>

}

export default NotesContext
export { ActionTypes }
